import { TournamentPayoutType } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';

const EMPTY_TOURNAMENT_DETAILS_PLACEHOLDER = {
  prizeAndDistribution: {
    lastWinningPosition: 0,
    payoutType: TournamentPayoutType.RankPosition,
    thresholdPercentage: 0,
  },
  teamsSettings: {
    maxTeams: 0,
  },
};

export const useLastWinningPosition = ({
  payoutType,
  thresholdPercentage,
  lastWinningPosition,
  maxTeams,
}: {
  payoutType: TournamentPayoutType;
  lastWinningPosition: number;
  thresholdPercentage: number;
  maxTeams: number;
}) => {
  return payoutType === TournamentPayoutType.TopPercent
    ? Math.ceil((thresholdPercentage * maxTeams) / 100)
    : lastWinningPosition;
};

export const useTournamentLastWinningPosition = (
  tournamentDetails?: Pick<TournamentEntity, 'prizeAndDistribution' | 'teamsSettings'>
) => {
  const prizeAndDistribution =
    tournamentDetails?.prizeAndDistribution ??
    EMPTY_TOURNAMENT_DETAILS_PLACEHOLDER.prizeAndDistribution;

  const teamsSettings =
    tournamentDetails?.teamsSettings ?? EMPTY_TOURNAMENT_DETAILS_PLACEHOLDER.teamsSettings;

  return useLastWinningPosition({
    payoutType: prizeAndDistribution.payoutType,
    lastWinningPosition: prizeAndDistribution.lastWinningPosition,
    thresholdPercentage: prizeAndDistribution.thresholdPercentage,
    maxTeams: teamsSettings.maxTeams,
  });
};
